<template>
  <div>
    <b-card no-body class="border mt-1">
      <b-card-header class="p-1">
        <b-card-title class="font-medium-2">
          <feather-icon icon="LockIcon" size="18" />
          <span class="align-middle ml-50">Permissões</span>
        </b-card-title>
      </b-card-header>
      <b-table striped responsive class="mb-0" :items="allPermissoes" :fields="tabelaPermissoes">
        <template #cell(status)="data">
          <div>
            <b-form-checkbox
                v-model="data.item.status"
                :checked="data.item.status"
                class="custom-control-success"
                name="check-button"
                switch
            />
          </div>
        </template>
      </b-table>
    </b-card>
    <!-- Action Buttons -->
    <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        type="submit"
        @click="() => onSubmit(perfilData,allPermissoes)"
    >
      Salvar Alterações
    </b-button>
    <b-button
        variant="outline-secondary"
        type="reset"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
    >
      Cancelar
    </b-button>
  </div>
</template>

<script>
import {
  BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import vSelect from 'vue-select';
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils';
import { ref } from '@vue/composition-api';
import store from '@/store';
import Notifier from '@/libs/Notifier';
import useUsersList from '../perfilAcesso-list/PerfilAcessoList.vue';

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
  },
  props: {
    perfilData: {
      type: Object,
      required: true,
    },
    allPermissoes: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const notify = new Notifier();
    const allPermissao = ref(null);
    const statusOptions = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
    ];

    const permissionsData = [
      {
        read: true,
        write: false,
        create: false,
        delete: false,
      },
    ];
    const onSubmit = (perfilData, allPermissao) => {
      console.log(allPermissao);
      const { id } = props.perfilData;
      store.dispatch('app-perfilAcesso/putPermissoesPerfilAcesso', { allPermissao, id })
        .then(() => {
          notify.success('Alterado com sucesso');
        });
    };

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const tabelaPermissoes = [
      { key: 'action', label: 'Ação', sortable: true },
      { key: 'subject', label: 'Assunto' },
      { key: 'status', label: 'Status' },
    ];
    return {
      tabelaPermissoes,
      onSubmit,
      statusOptions,
      permissionsData,
      refInputEl,
      previewEl,
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
